import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.footer`
  width: 100%;
  margin: 80px 0 0 0;
  background-color: var(--celeste90);
  border-top: 1px solid var(--grisClaro);
  overflow: hidden;

  .footer-contenido {
    max-width: 1140px;
    margin: 0 auto;
    padding: 64px 24px 48px 24px;
    position: relative;
    box-sizing: border-box;
  }

  // Ilustración de edificios de fondo (como en el diseño)
  .edificios {
    position: absolute;
    right: 40px;
    bottom: 0;
    height: 240px;
    opacity: 0.05;
    pointer-events: none;
  }

  .fila {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
    position: relative;
  }

  // Redes alineadas con la fila de sellos (sello más alto: 56px)
  .fila-sellos {
    margin: 56px 0 0 0;
    align-items: flex-start;
  }

  .fila-sellos .redes {
    margin: 9px 0 0 0;
  }

  .logo {
    height: 34px;
  }

  .contacto {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 24px;
  }

  .contacto a,
  .contacto span {
    font-family: "DM Sans", sans-serif;
    font-size: 14px;
    color: var(--lila90);
    text-decoration: none;
    transition: 0.2s all;
  }

  .contacto a:hover {
    color: var(--naranja100);
  }

  // Redes: círculos naranjas
  .redes {
    display: flex;
    gap: 12px;
  }

  .redes a {
    width: 38px;
    height: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: var(--naranja100);
    color: var(--blanco);
    font-size: 16px;
    transition: 0.2s all;
  }

  .redes a:hover {
    background-color: var(--naranja40);
  }

  // Sellos
  .sellos {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 16px 40px;
  }

  .sellos a {
    display: flex;
  }

  .sellos-bloque {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 16px;
  }

  .dato-ssn {
    margin: 0;
    font-family: "DM Sans", sans-serif;
    font-size: 12px;
    line-height: 1.7;
    color: var(--lila90);
    text-align: right;
  }

  .dato-ssn span {
    margin: 0 4px;
  }

  .dato-ssn a {
    font: inherit;
    color: var(--lila90);
    text-decoration: none;
    transition: 0.2s all;
  }

  .dato-ssn a:hover {
    color: var(--naranja100);
  }

  .sellos img {
    display: block;
  }

  .sello-encrypt {
    height: 28px;
  }

  .sello-ssn {
    height: 30px;
  }

  .sello-pdp {
    height: 40px;
  }

  .sello-fiscal {
    height: 56px;
  }

  // Copyright
  .copyright {
    max-width: 1140px;
    margin: 0 auto;
    padding: 20px 24px 28px 24px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 12px 24px;
    box-sizing: border-box;
    border-top: 1px solid var(--grisClaro);
  }

  .copyright p,
  .copyright a {
    margin: 0;
    font-family: "DM Sans", sans-serif;
    font-size: 12px;
    line-height: 1.7;
    color: var(--lila90);
  }

  .copyright p span {
    margin: 0 4px;
  }

  .copyright nav {
    display: flex;
    gap: 20px;
  }

  .copyright a {
    color: var(--lila80);
    text-decoration: none;
    transition: 0.2s all;
  }

  .copyright a:hover {
    color: var(--naranja100);
  }

  @media (max-width: ${breakpoints.tablet850}) {
    .fila {
      flex-direction: column;
      align-items: flex-start;
    }

    .sellos {
      justify-content: flex-start;
    }

    .sellos-bloque {
      align-items: flex-start;
    }

    .dato-ssn {
      text-align: left;
    }

    .edificios {
      height: 180px;
      right: 0;
    }
  }

  @media (max-width: ${breakpoints.mobile450}) {
    .footer-contenido {
      padding: 48px 16px 40px 16px;
    }

    .copyright {
      padding: 20px 16px 28px 16px;
    }

    .contacto {
      flex-direction: column;
    }

    .sellos {
      gap: 16px 28px;
    }

    // Los separadores pasan a ser saltos de línea
    .copyright p span,
    .dato-ssn span {
      display: block;
      height: 0;
      margin: 0;
      overflow: hidden;
    }
  }
`;

export default Container;
